import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import accountReducer from './accountReducer';
import chatReducer from './chatReducer';
import kanbanReducer from './kanbanReducer';
import mailReducer from './mailReducer';
import notificationsReducer from './notificationsReducer';

const rootReducer = combineReducers({
  account: accountReducer,
  chat: chatReducer,
  form: formReducer,
  kanban: kanbanReducer,
  mail: mailReducer,
  notifications: notificationsReducer
});

export default rootReducer;
